import { Link } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';

import { enableSection } from '@/content/homepage';

/**
 * "We enable donors…" style pathway strip (ICONIQ advisory / co-labs / awards rhythm).
 */
export function EnableBand() {
  return (
    <section
      aria-labelledby="enable-heading"
      className="border-border/70 border-b bg-card py-20 sm:py-24"
    >
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <p className="text-primary mb-4 text-xs font-semibold tracking-[0.24em] uppercase">
            {enableSection.eyebrow}
          </p>
          <h2
            id="enable-heading"
            className="font-display text-foreground text-3xl font-semibold tracking-tight text-balance sm:text-4xl"
          >
            {enableSection.heading}
          </h2>
        </div>

        <div className="mt-14 grid gap-8 md:grid-cols-3">
          {enableSection.items.map((item) => {
            const content = (
              <>
                <h3 className="font-display text-foreground text-xl font-semibold tracking-tight">
                  {item.title}
                </h3>
                <p className="text-muted-foreground mt-3 flex-1 text-sm leading-relaxed sm:text-[0.95rem]">
                  {item.body}
                </p>
                <span className="text-primary mt-6 inline-flex items-center gap-1 text-sm font-semibold">
                  {item.cta}
                  <ArrowUpRightIcon className="size-4" aria-hidden />
                </span>
              </>
            );

            const className =
              'group border-border/80 hover:border-primary/40 flex h-full flex-col rounded-2xl border bg-background p-7 transition-colors';

            if (item.external) {
              return (
                <a
                  key={item.id}
                  href={item.href}
                  target="_blank"
                  rel="noreferrer noopener"
                  className={className}
                >
                  {content}
                  <span className="sr-only">(opens in new tab)</span>
                </a>
              );
            }

            return (
              <Link key={item.id} to={item.href} className={className}>
                {content}
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
